

































import { supervisingModule } from '@/store/modules/OperationSupervising';
import { applicationFormModule } from '@/Uketsuke/store/modules/ApplicationForm';
import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableRadio extends Vue {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private privateInvaildMessage: string = '';
  private rules: any;
  private privateTextColor: string = '';
  // 20220803 [申請年度非活性] ishida ADD Start
  private isOrderUser = supervisingModule.IS_ORDER_USER;
  private shinki = !applicationFormModule.IS_SET_TRADER_ID;
  private processType = applicationFormModule.GET_PROCESS_TYPE;
  private isNendoDisabled: boolean = false;
  // 20220803 [申請年度非活性] ishida ADD End
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop() private hint?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop({default: false}) private required?: boolean;
  @Prop() private options!: [];
  @Prop() private invaildMessage?: string;
  @Prop() private textColor?: string;
  @Emit('input')
  private updateValue(value: string) {
    return value;
  }
  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    this.rules = [(value: string) => (this.isValidateRequired(value)) || '必須項目です。'];
// 20220803 [申請年度非活性] ishida ADD Start
    if (!this.isOrderUser) {
      // 受注者の場合
        if (this.processType) {
          // システムメインページの申請年度以外は非活性
          this.isNendoDisabled = true;
        }
    } else if (this.isOrderUser) {
      // 発注者の場合
      if (!this.shinki && this.processType) {
        // 新規、データ検索画面以外は非活性
        this.isNendoDisabled = true;
      }
    }
// 20220803 [申請年度非活性] ishida ADD End
  }
  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }

}
